import React from "react";
import { Link, Box, Typography, Tooltip } from "@mui/material";
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import { useQuestionBank } from "../../pages/questionBank/hooks";

export function QuestionBankCard({ question }) {
    const { remove } = useQuestionBank()
    const badgeStyles = styles.badgeOrange;
    const user = JSON.parse(localStorage.getItem("user"));
    const onDelete = () => {
        if (!confirm('Are you sure to delete this question?')) { return; }
        remove({ id: question.id, questionBank: true });
    }
    return (
        <Box>
            <Box
                sx={{
                    borderRadius: '10px',
                    background: 'var(--mui-palette-gray-lightGray50)',
                    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.1)',
                    maxWidth: '400px',
                    padding: '15px 5px 5px 15px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    transition: 'all .5s ease-in-out',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                        background: 'var(--mui-palette-primary-blue)',
                        boxShadow: '0 20px 40px rgba(61,65,84,.15)',
                        transform: 'translateY(-2px)',
                        transition: 'all .5s ease-in-out',
                        '& h6, & a, & .MuiSvgIcon-root, & .MuiBox-root': {
                            color: 'var(--mui-palette-common-white)',
                        }
                    },
                    '&::before': {
                        content: '""',
                        display: 'block',
                        height: '5px',
                        width: 0,
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        backgroundColor: 'var(--mui-palette-primary-orange)',
                        transition: 'all .5s ease-in-out',
                    },
                    '&:hover:before': {
                        width: '100%',
                    },
                    '& > *': {
                        position: 'relative',
                        zIndex: 1,
                    },
                }}
            >
                <Box>
                    <Typography
                        color="common.black"
                        align="left"
                        variant="h6"
                        sx={{
                            mb: 1.2,
                            fontSize: '1rem',
                            lineHeight: 1.4,
                            minHeight: '40px',
                            fontWeight: 'bold',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            paddingRight: '50px',
                            width: '60%'
                        }}
                    >
                        {question?.questionDetails?.text}
                    </Typography>
                    <Box sx={{ display: 'flex' }}>
                        <Box sx={{ ...styles.badge, ...badgeStyles }}>{question.type}</Box>
                    </Box>
                    <Box sx={styles.courseDetail}>
                        <Box sx={styles.detailItem}>
                            <Box sx={styles.itemHeading}>Mark:</Box>
                            <Box sx={styles.itemValue}>{question?.answerDetails?.options?.marks}</Box>
                        </Box>
                        <Box sx={styles.detailItem}>
                            <Box sx={styles.itemHeading}>Taxonomy:</Box>
                            <Box sx={styles.itemValue}>{question.taxonomy}</Box>
                        </Box>
                        <Box sx={styles.detailItem}>
                            <Box sx={styles.itemHeading}>Category:</Box>
                            <Box sx={styles.itemValue}>{question.category}</Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={styles.actionBtn}>
                    {question?.answerDetails?.options?.helpText?.text
                        &&
                        <Tooltip title={question?.answerDetails?.options?.helpText?.text}>
                            <InfoIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} />
                        </Tooltip>
                    }
                    {/* {(question?.updateHistory[0]?.updatedBy === user.userName)
                        && */}
                    <Link style={styles.actionBtnItem} href={`/question-bank/edit/${question.id}`} title="Edit Question"><CreateIcon sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} /></Link>
                    {/* } */}
                    {/* {(question?.updateHistory[0]?.updatedBy === user.userName)
                        && */}
                    <Link style={styles.actionBtnItem} onClick={onDelete} title="Delete Question">
                        <DeleteIcon sx={{ color: 'var(--mui-palette-error-dark)', fontSize: '1.2rem' }} />
                    </Link>
                    {/* } */}
                </Box>
            </Box>
        </Box>
    );
}

const styles = {
    courseDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginTop: '15px',
    },
    detailItem: {
        marginBottom: '10px',
    },
    itemHeading: {
        color: 'var(--mui-palette-primary-blue)',
        fontSize: '0.8rem',
        fontWeight: 600,
        marginBottom: '5px'
    },
    itemValue: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '0.9rem',
        minHeight: '32px'
    },
    badge: {
        padding: '6px 10px',
        backgroundColor: 'var(--mui-palette-primary-orange)',
        marginRight: '1rem',
        borderRadius: '6px',
        fontSize: '.7rem',
        fontWeight: '600',
        letterSpacing: '0.5px'
    },
    badgeGreen: {
        backgroundColor: 'var(--mui-palette-primary-dark)',
        color: 'var(--mui-palette-common-white)',
    },
    badgeOrange: {
        color: 'var(--mui-palette-common-white)',
        backgroundColor: 'var(--mui-palette-primary-orange)',
    },
    actionBtn: {
        textAlign: 'right',
        position: 'absolute',
        top: '10px',
        right: '10px',
        padding: '5px'

    },
    actionBtnItem: {
        marginLeft: '5px',
        marginRight: '5px',
        cursor: 'pointer'
    }
};

export default QuestionBankCard;
